import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';
import { GameDto } from '../../../models/game/dto/game.dto';
import { GAME_QUERY_KEY } from './useGetGame';

export interface UpdateGameTimesDto {
    startTime: string;
    duration: number;
}

export const useUpdateGameTimes = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async ({ gameId, data }: { gameId: number; data: UpdateGameTimesDto }) => {
            return apiClient.fetchApi<GameDto, UpdateGameTimesDto>({
                endpoint: `games/${gameId}/update-times`,
                method: 'PUT',
                body: data,
            });
        },
        onSuccess: (data, { gameId }) => {
            toast({
                title: translate('game.times_updated'),
                description: translate('game.times_updated_description'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });

            // Invalidate and refetch game details to update the UI
            queryClient.invalidateQueries({ queryKey: GAME_QUERY_KEY(gameId) });
        },
        onError: (error: any) => {
            toast({
                title: translate('game.error_updating_times'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
